export default "__VITE_ASSET__0PpaCf8I__"